import { httpClient } from '@/infra/protocols/http';

export async function getAccessToken(
  params: GetAccessTokenService.Params,
): Promise<GetAccessTokenService.Response> {
  const response = await httpClient.post<GetAccessTokenService.Response>(
    `/v1/auth/access-token`,
    { code: params.code, requestUri: params.requestUri },
    {
      safeErrorStatus: [401],
    },
  );
  return response;
}

export namespace GetAccessTokenService {
  export interface Params {
    code: string;
    requestUri: string;
  }

  export type Response = {
    scope: string;
    idToken: string;
    expiresIn: number;
    tokenType: string;
    accessToken: string;
    refreshToken: string;
    sessionState: string;
    refreshExpiresIn: number;
  };
}
